import { useQuery } from '@tanstack/react-query'
import { lcCoachingApi } from '@/api/lcCoaching'
import { coachingKeys } from './useCoachingToday'

export function useClassRoster(timeslotId: number | null) {
  return useQuery({
    queryKey: coachingKeys.roster(timeslotId ?? 0),
    queryFn: () => lcCoachingApi.getClassRoster(timeslotId as number),
    enabled: timeslotId != null && Number.isFinite(timeslotId) && timeslotId > 0,
    staleTime: 30_000,
  })
}

export function useTodayClassRosterSearch(query: string | null) {
  return useQuery({
    queryKey: coachingKeys.rosterSearch(query ?? ''),
    queryFn: () => lcCoachingApi.searchTodayClassRoster(query as string),
    enabled: query != null && query.length > 0,
    staleTime: 30_000,
  })
}
